import { render, staticRenderFns } from "./Despachos.vue?vue&type=template&id=0030fa61&"
import script from "./Despachos.vue?vue&type=script&lang=js&"
export * from "./Despachos.vue?vue&type=script&lang=js&"
import style0 from "./Despachos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports